var _style, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNose5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 43.9 37",
    style: {
      enableBackground: "new 0 0 43.9 37"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000183947381458939428690000016905647379429522855_);}\n\t.st2{fill:url(#SVGID_00000078032165326697570740000002535812944543813270_);}\n\t.st3{opacity:0.25;fill:url(#SVGID_00000067236819551002055080000002817993669860263570_);enable-background:new    ;}\n\t.st4{opacity:0.6;fill:url(#SVGID_00000123425682972891373610000001906740835165470100_);enable-background:new    ;}\n\t.st5{opacity:0.6;fill:url(#SVGID_00000120555763446306101100000014331194895377559685_);enable-background:new    ;}\n\t.st6{opacity:0.6;fill:url(#SVGID_00000054978281009942349260000003522771865216418715_);enable-background:new    ;}\n\t.st7{opacity:0.6;fill:url(#SVGID_00000094616790024538529550000013945236345010990503_);enable-background:new    ;}\n\t.st8{fill:#FFCCB8;}\n\t.st9{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.9656,
    y1: -73.5558,
    x2: 21.9656,
    y2: 267.5793,
    gradientTransform: "matrix(1 0 0 -1 0 37.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2AD97"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FAA67D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2352,
    style: {
      stopColor: "#FC9E7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2845,
    style: {
      stopColor: "#FBA47D",
      stopOpacity: 0.671
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#F9AB80",
      stopOpacity: 0
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.1,22.5c-0.4,0.9-1.6,1.7-3.2,2.4l0,0c-1.2,0.6-2.7,1.1-4,1.5c-0.5,0.2-1,0.3-1.4,0.4 c-0.3,0.1-0.6,0.2-0.8,0.2c-0.1,0-0.2,0.1-0.4,0.1c-0.1,0-0.2,0-0.3,0.1c-0.4,0.1-0.7,0.2-0.9,0.2l0,0l0,0 c-0.3,0.1-0.4,0.1-0.4,0.1l0,0c-0.1,0.1-2.4,3.2-9.7,3.2s-9.6-3.1-9.7-3.2l0,0c0,0-0.1,0-0.4-0.1l0,0l0,0c-0.1,0-0.1,0-0.2,0 c-0.2,0-0.4-0.1-0.7-0.2c-0.2-0.1-0.4-0.1-0.6-0.2c-0.4,0.1-0.7,0-1-0.1C9,26.8,8.5,26.6,8,26.5c-0.2,0-0.3-0.1-0.5-0.2 S7.2,26.2,7,26.1c-1-0.3-2-0.7-3-1.2l0,0c-1.6-0.7-2.8-1.6-3.2-2.4c-1.1-2.8-1.1-6.6,0.4-10C2.7,9.4,13.7,1.4,20.5,0.2 c0.1,0,0.3,0,0.4-0.1c0.2,0,0.3,0,0.5-0.1c0.1,0,0.9,0,1,0c0.8,0.1,1.7,0.2,2.6,0.5l0,0c6.9,2,16.3,9.1,17.6,11.9 C44.2,15.9,44.3,19.7,43.1,22.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122681827382993227760000002595160371452360379_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.3904,
    y1: 8.2895,
    x2: 10.2076,
    y2: -0.797,
    gradientTransform: "matrix(1 0 0 -1 0 37.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#77254B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8B2542"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122681827382993227760000002595160371452360379_)"
    },
    d: "M11.8,27.5 C11.8,27.6,11.8,27.6,11.8,27.5C11.8,27.6,11.8,27.6,11.8,27.5c-0.1,0-0.2,0-0.3,0c-0.2,0-0.4-0.1-0.7-0.2 c-0.2-0.1-0.4-0.1-0.6-0.2c-0.2,0-0.5-0.1-0.8-0.2C9,26.8,8.5,26.6,8,26.5c-0.2,0-0.3-0.1-0.5-0.2S7.2,26.2,7,26.1 c-1-0.3-2-0.7-3-1.2l0,0c-1.5-1.3,0-3.8,2.7-2c1.5,1,4.1,3.5,4.9,4.3C11.7,27.4,11.8,27.5,11.8,27.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088836979206899080600000007689356777599186827_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.7896,
    y1: 10.4701,
    x2: 37.8532,
    y2: 5.1522,
    gradientTransform: "matrix(1 0 0 -1 0 37.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#77254B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8B2542"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088836979206899080600000007689356777599186827_)"
    },
    d: "M40,24.9L40,24.9c-1.2,0.6-2.7,1.1-4,1.5 c-0.5,0.2-1,0.3-1.4,0.4C34.3,26.9,34,27,33.8,27c-0.1,0-0.2,0.1-0.4,0.1c-0.1,0-0.2,0-0.3,0.1c-0.4,0.1-0.7,0.2-0.9,0.2l0,0l0,0 c0,0,0.1-0.1,0.3-0.3c0.2-0.2,0.5-0.6,0.9-1c1.2-1.1,2.9-2.6,4-3.4C40,21.1,41.5,23.6,40,24.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160892116246530583200000000017922519535591573_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.3941,
    y1: 40.1619,
    x2: 22.3941,
    y2: 9.8764,
    gradientTransform: "matrix(1 0 0 -1 0 37.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB39D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2251,
    style: {
      stopColor: "#FF9B8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    style: {
      stopColor: "#FF8781"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#FF7B7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7777"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "url(#SVGID_00000160892116246530583200000000017922519535591573_)",
      enableBackground: "new"
    },
    d: " M22.1,0c-10.2,0-9.8,19.8-9.7,20.4c0.3,3.6,5.3,4.8,10.3,4.6c4.8-0.2,9.6-1.5,9.7-4.5C32.6,14.4,31.3,0,22.1,0z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044860506662723709290000000342896721666564261_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.0174,
    y1: 32.5636,
    x2: 22.0174,
    y2: 7.4168,
    gradientTransform: "matrix(1 0 0 -1 0 37.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE9DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CE5982"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000044860506662723709290000000342896721666564261_)",
      enableBackground: "new"
    },
    d: " M42.7,12.5c0.8,4.7,0.1,8.5-2.1,7.7c-1.9-0.7-5.7,1.3-8.5,3.3c-0.8,0.6-7.7,2.3-10.1,2.4c-2.4-0.1-9.3-1.8-10.1-2.4 c-2.7-2-6.6-4-8.5-3.3c-2.2,0.8-2.9-3-2.1-7.7c-1.5,3.3-1.6,7.2-0.4,10c0.4,0.9,1.6,1.7,3.2,2.4l0,0C4.6,25.1,6.7,26,9,26.7 c1.8,0.5,3.4,0.9,3.4,0.9l0,0c0.1,0.1,2.4,3.2,9.7,3.2l0,0l0,0c7.3,0,9.6-3.1,9.7-3.2l0,0c0,0,1.9-0.4,4-1.1 c1.8-0.6,3.8-1.4,4.3-1.6l0,0c1.6-0.7,2.8-1.6,3.2-2.4C44.3,19.7,44.2,15.9,42.7,12.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051351391885150516920000004865918382667429791_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.7281,
    y1: 25.9125,
    x2: 22.5669,
    y2: -2.5489,
    gradientTransform: "matrix(1 0 0 -1 0 37.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE9DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CE5982"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000051351391885150516920000004865918382667429791_)",
      enableBackground: "new"
    },
    d: " M40.6,20.2c-1.9-0.7-5.7,1.3-8.5,3.3c-0.8,0.6-7.7,2.3-10.1,2.4c-2.4-0.1-9.3-1.8-10.1-2.4c-2.7-2-6.6-4-8.5-3.3 c-2.2,0.8-2.6,2-2.6,2.3C1,22.9,8.2,37,22,37s21-14.1,21.2-14.5C43.5,21.7,42.8,21,40.6,20.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026872756223106499190000009551470321270489227_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.2141,
    y1: 26.0816,
    x2: 9.83,
    y2: 15.9198,
    gradientTransform: "matrix(1 0 0 -1 0 37.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE9DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CE5982"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000026872756223106499190000009551470321270489227_)",
      enableBackground: "new"
    },
    d: " M11.8,23.5c-1.3-0.9-2.6-1.8-3.9-2.4c0,0,0.4-10-0.8-14.2C7.1,6.9,8.8,16.2,11.8,23.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084520634160500036060000002708848131117204108_",
    gradientUnits: "userSpaceOnUse",
    x1: -5674.0317,
    y1: 26.083,
    x2: -5673.416,
    y2: 15.9212,
    gradientTransform: "matrix(-1 0 0 -1 -5639.3462 37.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE9DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CE5982"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000084520634160500036060000002708848131117204108_)",
      enableBackground: "new"
    },
    d: " M32.1,23.5c1.3-0.9,2.6-1.8,3.9-2.4c0,0-0.4-10,0.8-14.2C36.9,6.9,35.1,16.2,32.1,23.5z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M13.9,21.7l17.8,0.6c0,0-3.3,2.5-9.7,2.3S13.9,21.7,13.9,21.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M16.2,22.2c2.2-0.1,13.2,0.2,13.2,0.2l-6.7,1.2L16.2,22.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNose5);
export default __webpack_public_path__ + "static/media/Nose5.7ad424b5729b266488f69ba47d726c11.svg";
export { ForwardRef as ReactComponent };